import { Dispatch } from 'react';
import {
  GET_DESK_LIST,
  GET_DESK,
  PUT_DESK,
  POST_DESK,
  DeleteDeskAction,
  DELETE_DESK,
  UpdateDeskFiltersAction,
  UPDATE_DESK_FILTERS
} from '../types/desk.types';
import { CoreApi } from '../../../api/api.apiclient';
import { DeskListFilters, DeskRequest, EditDeskRequest } from '../../../api/core/core.types';
import { PageRequest } from '../../../api/api.types';

export const getDeskList = (filters?: DeskListFilters, pageRequest?: PageRequest) => async (dispatch: Dispatch<any>): Promise<void> => {
  const response = await CoreApi.Desks.listAllDesks(filters, pageRequest);

  dispatch({
    type: GET_DESK_LIST,
    payload: {
      page: response.data
    }
  });

  return Promise.resolve();
};

export const getDesk = (code: string) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await CoreApi.Desks.getOneDesk(code);

    dispatch({
      type: GET_DESK,
      payload: {
        selectedDesk: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_DESK,
      payload: {
        selectedDesk: null
      }
    });
  }
};

export const editDesk = (code: string, request: EditDeskRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.Desks.editDesk(code, request);

  dispatch({
    type: PUT_DESK,
    payload: {
      selectedDesk: response.data
    }
  });
};

export const addNewDesk = (request: DeskRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.Desks.addNewDesk(request);

  dispatch({
    type: POST_DESK,
    payload: {
      selectedDesk: response.data,
      success: true
    }
  });
};

export const deleteDesk = (code: string) => async (dispatch: Dispatch<DeleteDeskAction>) => {
  await CoreApi.Desks.deleteDesk(code);
  dispatch({
    type: DELETE_DESK,
    payload: {
      success: true
    }
  });
};

export const updateDeskFilters = (filters: DeskListFilters) => async (dispatch: Dispatch<UpdateDeskFiltersAction>) => {
  dispatch({
    type: UPDATE_DESK_FILTERS,
    payload: {
      filters
    }
  });
};
